import script from "./AscendPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AscendPage.vue?vue&type=script&setup=true&lang=js"

import "./AscendPage.vue?vue&type=style&index=0&id=26182094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26182094"]])

export default __exports__